import gql from "graphql-tag";

export const MY_LEAVE_USERS_TO_EXAMINER_DASHBOARD = gql`
  mutation usersToExaminerDashboard(
    $roleFilters: RoleFilterInput
    $sortField: String
    $sortDirection: String
    $searchField: String
    $searchText: String
    $role: String
    $startDate: Date
    $endDate: Date
    $page: Int
    $pageSize: Int
  ) {
    usersToExaminerDashboard(
      roleFilters: $roleFilters
      sortField: $sortField
      sortDirection: $sortDirection
      searchField: $searchField
      searchText: $searchText
      role: $role
      startDate: $startDate
      endDate: $endDate
      page: $page
      pageSize: $pageSize
    ) {
      rows {
        contract
        employee
        name
        orgUnit
        jobClass
        allLeavesCount
        pastRequestedLeavesCount
        currentRequestedLeavesCount
        futureRequestedLeavesCount
      }
      total
      page
      pageSize
      totalPages
      allLeavesCount
      allUsersCount
    }
  }
`;
